<div class="detail-page" [class.detail-page--leaving]="isLeaving()">
  <button class="back-link" (click)="goBack()" title="Back to projects" aria-label="Back to projects">
    <span class="material-icons">arrow_back</span>
  </button>

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (notFound()) {
    <app-empty-state message="This project doesn't exist, or you don't have access to it." />
  } @else {
    <app-error-banner [message]="errorMessage()" />

    @if (project(); as p) {
      <div class="detail-header">
        <div class="detail-header__top">
          <span class="project-code">{{ p.code }}</span>

          @if (canManageStatus && statusActions.length > 0) {
            <button
              class="status-control"
              [matMenuTriggerFor]="statusMenu"
              [disabled]="isUpdatingStatus()"
              title="Change status"
            >
              <app-status-badge [status]="p.status" />
              <span class="material-icons status-control__chevron">expand_more</span>
            </button>
            <mat-menu #statusMenu="matMenu" class="status-menu-panel">
              @for (action of statusActions; track action.status) {
                <button mat-menu-item [class.status-menu-item--danger]="action.danger" (click)="transitionStatus(action)">
                  <mat-icon>{{ action.icon }}</mat-icon>
                  <span>{{ action.label }}</span>
                </button>
              }
            </mat-menu>
          } @else {
            <app-status-badge [status]="p.status" />
          }
        </div>
        <h1>{{ p.name }}</h1>
        @if (p.description) {
          <p class="project-description">{{ p.description }}</p>
        }
        <span class="project-date">Created {{ p.createdAt | date: 'medium' }}</span>
      </div>

      @if (canRaiseExportRequest) {
        @if (p.status === 'ACTIVE') {
          <a [routerLink]="['/projects', projectId, 'export-requests', 'new']" class="raise-btn">
            Raise export request
          </a>
        } @else {
          <p class="raise-blocked">
            <span class="material-icons">info</span>
            This project is {{ p.status | lowercase }}, so no new export requests can be raised on it.
            @if (p.status === 'SUSPENDED') {
              Resume it to continue.
            }
          </p>
        }
      }

      <section class="participants-section">
        <div class="participants-header">
          <h2>Participants</h2>
          @if (canManageParticipants) {
            <button class="add-participant-btn" (click)="openAddParticipantDialog()">Add participant</button>
          }
        </div>

        @if (p.participants.length === 0) {
          <app-empty-state message="No participants yet." />
        } @else {
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Registration No.</th>
                <th>Country</th>
                <th>Status</th>
                @if (canManageParticipants) {
                  <th></th>
                }
              </tr>
            </thead>
            <tbody>
              @for (participant of p.participants; track participant.id) {
                <tr [class.row--removed]="participant.status === 'REMOVED'">
                  <td>{{ participant.companyName }}</td>
                  <td>{{ participant.registrationNo }}</td>
                  <td>{{ participant.countryCode }}</td>
                  <td><app-status-badge [status]="participant.status" /></td>
                  @if (canManageParticipants) {
                    <td>
                      @if (participant.status !== 'REMOVED') {
                        <button
                          class="remove-btn"
                          (click)="confirmRemoveDialog(participant.companyId, participant.companyName)"
                          aria-label="Remove participant"
                          title="Remove participant"
                        >
                          <svg class="bin-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <g class="bin-icon__lid">
                              <line x1="4" y1="7" x2="20" y2="7" />
                              <path d="M10 7V4.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V7" />
                            </g>
                            <path d="M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13" />
                            <line x1="10" y1="11" x2="10" y2="17" />
                            <line x1="14" y1="11" x2="14" y2="17" />
                          </svg>
                        </button>
                      } @else if (reactivatingCompanyId() === participant.companyId) {
                        <span class="confirm-text">Reactivating...</span>
                      } @else {
                        <button
                          class="link-btn"
                          (click)="reactivate(participant.companyId, participant.registrationNo)"
                        >
                          Reactivate
                        </button>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        }
      </section>
    }
  }
</div>
